module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA2klEQVQ4T+2TsQ2DQAxFbSGos0GyQRiBETICbBAKTEtrN6zABmGDMAKjpAYJIqMjAnFAUNq4Pj/7f/9D+LFQ+5n5hoiPg6yIiIoBICJ+3/eF53lBHMevLVCe56e2bZ8AoIB6ABhICAAhEQVbABEpAaDU6fruAzBSMkQ8E1FkgzBzBgCXNE112FAzgNlkNmFvwwVANTZNUyGiyqn3PFoAxgbV6bqur6Yycz0FTuVZAQaiW2RJklQiUq2Z+wdYcjA6bEJz7boudhynOGziJN6aPo3u3ZbO1St8+zPfRiqDET4aaYsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/funnel.png
// module id = Q77T
// module chunks = 1